import { defineStore } from 'pinia'

import type { ExtraRatesStore } from './interfaces'

import { ShortDaysOfWeek } from '@brighterly/lib-core-types/options/enums'

import { actions } from './actions'
import { getters } from './getters'

export const useExtraRatesStore = defineStore('extra-rates', {
  state: (): ExtraRatesStore => ({
    loading: false,
    saving: false,
    daysOfWeek: [],
    tabId: ShortDaysOfWeek.Monday,
  }),
  actions,
  getters,
})
